<template>
	<div class="desktop-banner">
		<p class="desktop-banner__text">{{ text }}</p>
	</div>
</template>

<script setup>
const props = defineProps({
	fields: { type: Object, required: true },
	rendering: { type: Object, required: false },
});

const text = computed(() => props.fields?.text?.value);
</script>

<style lang="scss">
.desktop-banner {
	background: rgba(228, 8, 8, 0.8);
	position: fixed;
	left: 0;
	right: 0;
	bottom: 0;
	height: 44px;
	display: none;
	align-items: center;
	justify-content: center;
	z-index: 8;
	margin: 0 auto;

	.desktop-banner__text {
		color: var(--color-white, #fff);
		font-size: var(--text-base, 16px);
		text-transform: uppercase;
		text-align: center;
		margin: 0;
		font-family: var(--primary-font, sans-serif);
	}
}
</style>
